import { useMemo } from 'react';

import { ModifyAllowedEntity } from '@components/IsModificationAllowed/types';

const MODIFY_KEY = 'isModifyAllowed';

const checkEntity = (
  entity: ModifyAllowedEntity,
): entity is ModifyAllowedEntity =>
  entity && MODIFY_KEY in entity ? entity[MODIFY_KEY] : true;

export const useIsModifyAllowed = <T extends ModifyAllowedEntity>(
  entity: T | T[],
) => {
  const isModifyAllowed = useMemo(() => {
    if (Array.isArray(entity)) {
      return entity.every(checkEntity);
    }

    return checkEntity(entity);
  }, [entity]);

  return { isModifyAllowed };
};
